import * as React from "react";
import Spinner from "react-bootstrap/Spinner";

export const OkButtonSpinner: React.FC = props => {
    return <Spinner animation="border" size="sm" variant="light" />
}